"use client"

import type React from "react"
import { useAuth } from "@/components/auth-provider"
import { useRouter, usePathname } from "next/navigation"
import { useEffect, useRef } from "react"

interface RoleBasedRouterProps {
  children: React.ReactNode
}

export function RoleBasedRouter({ children }: RoleBasedRouterProps) {
  const { user, isLoading, isAuthenticated } = useAuth()
  const router = useRouter()
  const pathname = usePathname()
  const hasInitiallyRouted = useRef(false)

  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      console.log("[v0] RoleBasedRouter - Routing check")
      console.log("[v0] RoleBasedRouter - Current path:", pathname)
      console.log("[v0] RoleBasedRouter - User role:", user.role)
      console.log("[v0] RoleBasedRouter - User email:", user.email)

      // Auto-route based on user role - check on every path change
      switch (user.role) {
        case "organization":
        case "org": // Added support for "org" role from backend
          // Route organization users to their portal unless already there
          if (!pathname.startsWith("/organization/")) {
            console.log("[v0] RoleBasedRouter - Routing organization user to organization portal")
            router.replace("/organization/dashboard")
          }
          break
        case "client":
          // Route client users to their portal unless already there
          if (!pathname.startsWith("/client/")) {
            console.log("[v0] RoleBasedRouter - Routing client user to client portal")
            router.replace("/client/dashboard")
          }
          break
        case "internal":
        default:
          if (pathname.startsWith("/organization/") || pathname.startsWith("/client/")) {
            console.log("[v0] RoleBasedRouter - Routing internal user to main dashboard")
            router.replace("/")
          }
          break
      }
    } else if (!isLoading && !isAuthenticated) {
      hasInitiallyRouted.current = false
      console.log("[v0] RoleBasedRouter - User not authenticated, resetting routing flag")
    } else {
      console.log("[v0] RoleBasedRouter - Not routing:", {
        isLoading,
        isAuthenticated,
        hasUser: !!user,
        hasRouted: hasInitiallyRouted.current,
      })
    }
  }, [user, isLoading, isAuthenticated, router, pathname])

  return <>{children}</>
}
